"use client"

export function StarfieldBackground() {
    return (
        <>
            {/* Starfield particle layer */}
            <div className="starfield" aria-hidden="true" />

            {/* Edge glow effects */}
            <div className="edge-glow edge-glow-top" aria-hidden="true" />
            <div className="edge-glow edge-glow-left" aria-hidden="true" />
            <div className="edge-glow edge-glow-right" aria-hidden="true" />
        </>
    )
}

export default StarfieldBackground
